import { combineReducers } from '@reduxjs/toolkit';
import { Disclaimer, ProviderSearchFilterState } from 'store/findProvider/types';
import hospitalsReducer, { HospitalsState } from './hospitals';
import clinicsReducer, { ClinicsState } from './clinics';
import languagesReducer, { LanguageState } from './language';
import insurancesReducer, { insuranceState } from './insurance';
import specialtiesReducer, { SpecialtiesState } from './specialties';
import searchFilterReducer from './searchFilter';
import searchResultReducer, { SearchResultState } from './searchResult';
import providerDetailsReducer, { ProviderDetailState } from './providerDetail';
import providerCommentsReducer from './providerComments';
import metadataReducer, { MetadataState } from './metadata';
import disclaimerReducer from './disclaimer';
import suggestionsReducer, { SuggestionsState } from './suggestions';

export interface FindProvider {
  hospitals: HospitalsState;
  clinics: ClinicsState;
  languages: LanguageState;
  insurances: insuranceState;
  specialties: SpecialtiesState;
  disclaimer: Disclaimer;
  searchFilter: ProviderSearchFilterState;
  searchResult: SearchResultState;
  providerDetails: ProviderDetailState;
  metadata: MetadataState;
  suggestions: SuggestionsState;
}

export default combineReducers({
  hospitals: hospitalsReducer,
  clinics: clinicsReducer,
  languages: languagesReducer,
  insurances: insurancesReducer,
  specialties: specialtiesReducer,
  disclaimer: disclaimerReducer,
  searchFilter: searchFilterReducer,
  searchResult: searchResultReducer,
  providerDetails: providerDetailsReducer,
  providerComments: providerCommentsReducer,
  metadata: metadataReducer,
  suggestions: suggestionsReducer
});
